import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { EventInfoWithConsentResponse, InvestorMeetingCreateRequest, InvestorSlotUpdate, RegisterInvestorResponse } from '@ent-regis/entregis-ts-angular';
import { combineLatest } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';
import { msg } from '../constants/msg';
import { shouldShowInstitutionalInvestorType } from '../functions/register-investor.function';
export class InvestorComponent {
    constructor(route, registerInvestorService, eventService, alert, formUtils, investorSlotService, investorMeetingRequestService, loginLayout) {
        this.route = route;
        this.registerInvestorService = registerInvestorService;
        this.eventService = eventService;
        this.alert = alert;
        this.formUtils = formUtils;
        this.investorSlotService = investorSlotService;
        this.investorMeetingRequestService = investorMeetingRequestService;
        this.loginLayout = loginLayout;
        this.now = new Date();
        this.eventTypeEnum = EventInfoWithConsentResponse.EventTypeEnum;
        this.isClosedRegis = false;
        this.leave = true;
        this.defaultMeetingType = InvestorMeetingCreateRequest.MeetingTypeEnum.GROUP;
        this.defaultMeetingPriority = InvestorMeetingCreateRequest.MeetingPriorityEnum.MEDIUM;
        this.activeTab = 'information';
        this.lastSavedProfile = null;
        this.lastSavedCompanySelection = null;
        this.lastSavedTimeSelection = null;
    }
    get profileForm() {
        return this.form.get('profile');
    }
    get companySelectionForm() {
        return this.form.get('companySelection');
    }
    get timeSelectionForm() {
        return this.form.get('timeSelection');
    }
    ngOnInit() {
        this.getRegisterInvestorId();
        this.initializePage();
    }
    initializePage() {
        combineLatest([
            this.eventService.eventSubject.pipe(first(event => event != null)),
            this.registerInvestorService.investorProfile.pipe(first()),
            this.registerInvestorService.investorMeetingRequest.pipe(first()),
            this.registerInvestorService.investorSlots.pipe(first()),
        ])
            .subscribe(([event, investor, meetingRequest, slots]) => {
            this.setEventInfo(event);
            this.attendancePreference = investor.attendancePreference;
            this.defaultMeetingType = this.getDefaultMeetingType(this.attendancePreference);
            this.form = new FormGroup({
                profile: this.createProfileForm(),
                companySelection: new FormGroup({ companies: new FormArray([]) }),
                timeSelection: new FormGroup({ slots: new FormArray([]) })
            });
            this.setProfileForm(investor);
            this.setCompanyForm(meetingRequest);
            this.setTimeSelectionForm(slots);
            this.captureProfileSnapshot();
            this.captureCompanySelectionSnapshot();
            this.captureTimeSelectionSnapshot();
            this.investorProfile = investor;
            this.registerInvestorService.isCloseRegister.next(investor.isCloseRegister);
            this.loginLayout.setBackgroundUrl(this.eventInfoWithConsent.bgUrl);
        });
    }
    setEventInfo(event) {
        this.isShowHotel = event.isShowHotel;
        this.startDate = event.startDateRegisterInvestor;
        this.endDate = event.endDateRegisterInvestor;
        this.isClosedRegis = event.isCloseRegisterInvestor;
        this.eventType = event.eventType;
        this.eventInfoWithConsent = event;
    }
    createProfileForm() {
        return new FormGroup({
            coHostName: new FormControl(null, this.eventInfoWithConsent.isShowSalePersonForInvestorRegistration ? Validators.required : null),
            brokerName: new FormControl(''),
            hasSalePerson: new FormControl(true),
            seminarSubEvent: new FormControl(null),
            attendancePreference: new FormControl('', this.eventType === EventInfoWithConsentResponse.EventTypeEnum.THAILANDFOCUS ? Validators.required : null),
            companyName: new FormControl('', Validators.required),
            firstName: new FormControl('', Validators.required),
            lastName: new FormControl('', Validators.required),
            email: new FormControl('', [Validators.required, Validators.email]),
            mobileNumber: new FormControl('', Validators.required),
            extNumber: new FormControl(''),
            jobTitle: new FormControl('', Validators.required),
            department: new FormControl('', Validators.required),
            countryId: new FormControl(null, Validators.required),
            institutionalInvestorTypeId: new FormControl(null, shouldShowInstitutionalInvestorType(this.eventInfoWithConsent) ? Validators.required : null),
            otherInstitutionalInvestorType: new FormControl(''),
            assistantFirstName: new FormControl(''),
            assistantLastName: new FormControl(''),
            assistantEmail: new FormControl('', Validators.email),
            assistantMobileNumber: new FormControl(''),
            assistantExtNumber: new FormControl('')
        }, {
            validators: this.duplicateEmailValidator()
        });
    }
    duplicateEmailValidator() {
        return (group) => {
            const attendeeControl = group.get('email');
            const assistantContol = group.get('assistantEmail');
            const attendeeEmail = attendeeControl.value;
            const assistantEmail = assistantContol.value;
            this.formUtils.removeError(attendeeControl, 'duplicateEmail');
            this.formUtils.removeError(assistantContol, 'duplicateEmail');
            if (!attendeeEmail || !assistantEmail) {
                return null;
            }
            if (attendeeEmail === assistantEmail) {
                this.formUtils.setError(attendeeControl, 'duplicateEmail', true);
                this.formUtils.setError(assistantContol, 'duplicateEmail', true);
                return { duplicateEmail: true };
            }
            return null;
        };
    }
    goTab(tab) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.activeTab === tab) {
                return;
            }
            if (this.activeTab === 'information' && this.hasProfileChanged()) {
                this.discardProfileModal(tab);
                return;
            }
            if (this.activeTab === 'company' && this.hasCompanySelectionChanged()) {
                this.discardCompanySelectionModal(tab);
                return;
            }
            if (this.activeTab === 'availableTime' && this.hasTimeSelectionChanged()) {
                this.discardTimeSelectionModal(tab);
                return;
            }
            this.activeTab = tab;
        });
    }
    captureProfileSnapshot() {
        this.lastSavedProfile = JSON.parse(JSON.stringify(this.profileForm.value));
    }
    hasProfileChanged() {
        const currentValue = Object.assign({}, this.profileForm.value, { brokerName: this.profileForm.value.brokerName ? this.profileForm.value.brokerName : this.profileForm.value.coHostName, mobileNumber: this.profileForm.value.mobileNumber && this.profileForm.value.mobileNumber.number
                ? this.profileForm.value.mobileNumber.number : this.profileForm.value.mobileNumber, assistantMobileNumber: this.profileForm.value.assistantMobileNumber && this.profileForm.value.assistantMobileNumber.number
                ? this.profileForm.value.assistantMobileNumber.number : this.profileForm.value.assistantMobileNumber });
        const savedValue = Object.assign({}, this.lastSavedProfile, { brokerName: this.profileForm.value.brokerName ? this.profileForm.value.brokerName : this.profileForm.value.coHostName, mobileNumber: this.lastSavedProfile.mobileNumber && this.lastSavedProfile.mobileNumber.number
                ? this.lastSavedProfile.mobileNumber.number : this.lastSavedProfile.mobileNumber, assistantMobileNumber: this.lastSavedProfile.assistantMobileNumber && this.lastSavedProfile.assistantMobileNumber.number
                ? this.lastSavedProfile.assistantMobileNumber.number : this.lastSavedProfile.assistantMobileNumber });
        return JSON.stringify(currentValue) !== JSON.stringify(savedValue);
    }
    restoreProfileSnapshot() {
        this.profileForm.reset(this.lastSavedProfile);
        this.profileForm.markAsPristine();
        this.profileForm.markAsUntouched();
    }
    discardProfileModal(tab) {
        this.alert.showDiscardChanges().then((result) => {
            if (result.isConfirmed) {
                this.restoreProfileSnapshot();
                this.activeTab = tab;
            }
        });
    }
    captureCompanySelectionSnapshot() {
        this.lastSavedCompanySelection = JSON.parse(JSON.stringify(this.companySelectionForm.value));
    }
    hasCompanySelectionChanged() {
        if (!this.lastSavedCompanySelection) {
            return false;
        }
        return JSON.stringify(this.companySelectionForm.value) !== JSON.stringify(this.lastSavedCompanySelection);
    }
    restoreCompanySelectionSnapshot() {
        const snapshotCompanies = this.lastSavedCompanySelection && this.lastSavedCompanySelection.companies
            ? this.lastSavedCompanySelection.companies
            : [];
        const companyControls = snapshotCompanies.map((company) => new FormGroup({
            registerCompanyId: new FormControl(company.registerCompanyId),
            investorMeetingRequestId: new FormControl(company.investorMeetingRequestId),
            meetingType: new FormControl(company.meetingType),
            meetingPriority: new FormControl(company.meetingPriority),
        }));
        this.companySelectionForm.setControl('companies', new FormArray(companyControls));
        this.companySelectionForm.markAsPristine();
        this.companySelectionForm.markAsUntouched();
    }
    discardCompanySelectionModal(tab) {
        this.alert.showDiscardChanges().then((result) => {
            if (result.isConfirmed) {
                this.restoreCompanySelectionSnapshot();
                this.activeTab = tab;
            }
        });
    }
    captureTimeSelectionSnapshot() {
        this.lastSavedTimeSelection = JSON.parse(JSON.stringify(this.timeSelectionForm.value));
    }
    hasTimeSelectionChanged() {
        if (!this.lastSavedTimeSelection) {
            return false;
        }
        return JSON.stringify(this.timeSelectionForm.value) !== JSON.stringify(this.lastSavedTimeSelection);
    }
    restoreTimeSelectionSnapshot() {
        const snapshotSlots = this.lastSavedTimeSelection && this.lastSavedTimeSelection.slots
            ? this.lastSavedTimeSelection.slots
            : [];
        const slotControls = snapshotSlots.map((slot) => new FormGroup({
            slotDate: new FormControl(slot.slotDate),
            slotId: new FormControl(slot.slotId),
            slotPeriods: this.createSlotPeriodsFormArray(slot.slotPeriods)
        }));
        this.timeSelectionForm.setControl('slots', new FormArray(slotControls, this.validateAvailableTime()));
        this.timeSelectionForm.markAsPristine();
        this.timeSelectionForm.markAsUntouched();
    }
    discardTimeSelectionModal(tab) {
        this.alert.showDiscardChanges().then((result) => {
            if (result.isConfirmed) {
                this.restoreTimeSelectionSnapshot();
                this.activeTab = tab;
            }
        });
    }
    getRegisterInvestorId() {
        this.route.paramMap
            .pipe(map((x) => x.get('registerInvestorId')))
            .subscribe((x) => {
            this.registerInvestorService.registerInvestorId.next(+x);
        });
    }
    setCompanyForm(meetingList) {
        const meetings = Array.isArray(meetingList) ? meetingList : [];
        const companyControls = meetings
            .filter(meetingReq => meetingReq.investorMeetingRequestId)
            .map((meetingReq) => {
            const normalized = this.normalizeSelection(meetingReq.meetingType, meetingReq.priority);
            return new FormGroup({
                registerCompanyId: new FormControl(meetingReq.registerCompanyId),
                investorMeetingRequestId: new FormControl(meetingReq.investorMeetingRequestId),
                meetingType: new FormControl(normalized.meetingType),
                meetingPriority: new FormControl(normalized.meetingPriority),
            });
        });
        this.companySelectionForm.setControl('companies', new FormArray(companyControls));
    }
    setTimeSelectionForm(slots) {
        const slotControls = slots.map((slot) => new FormGroup({
            slotDate: new FormControl(slot.slotDate),
            slotId: new FormControl(slot.slotId),
            slotPeriods: this.createSlotPeriodsFormArray(slot.slotPeriods)
        }));
        this.timeSelectionForm.setControl('slots', new FormArray(slotControls, this.validateAvailableTime()));
    }
    createSlotPeriodsFormArray(slotPeriods) {
        return new FormArray(slotPeriods.map(sp => new FormGroup({
            investSlotId: new FormControl(sp.investSlotId),
            description: new FormControl(sp.description),
            endTime: new FormControl(sp.endTime),
            slotPeriodId: new FormControl(sp.slotPeriodId),
            startTime: new FormControl(sp.startTime),
            isAvailable: new FormControl(sp.available === 'Y' || sp.isAvailable)
        })));
    }
    validateAvailableTime() {
        const validator = (formArrays) => {
            const arrays = formArrays.value.map(m => m.slotPeriods);
            const flattenArrays = [].concat.apply([], arrays);
            const result = flattenArrays.map((m) => m.isAvailable).filter((f) => f).length > 0;
            return result ? null : { selectAtLeaseOneAvailableTime: true };
        };
        return validator;
    }
    getDefaultMeetingType(attendancePreference) {
        return attendancePreference === RegisterInvestorResponse.AttendancePreferenceEnum.VIRTUAL
            ? InvestorMeetingCreateRequest.MeetingTypeEnum.VIRTUALGROUP
            : InvestorMeetingCreateRequest.MeetingTypeEnum.GROUP;
    }
    normalizeSelection(meetingType, meetingPriority) {
        const isVirtualPreference = this.attendancePreference === RegisterInvestorResponse.AttendancePreferenceEnum.VIRTUAL;
        const isPhysicalPreference = this.attendancePreference === RegisterInvestorResponse.AttendancePreferenceEnum.PHYSICAL;
        if (isVirtualPreference && meetingType !== InvestorMeetingCreateRequest.MeetingTypeEnum.VIRTUALGROUP) {
            return {
                meetingType: InvestorMeetingCreateRequest.MeetingTypeEnum.VIRTUALGROUP,
                meetingPriority: meetingPriority || this.defaultMeetingPriority,
            };
        }
        if (isPhysicalPreference && meetingType === InvestorMeetingCreateRequest.MeetingTypeEnum.VIRTUALGROUP) {
            return {
                meetingType: this.defaultMeetingType,
                meetingPriority: meetingPriority || this.defaultMeetingPriority,
            };
        }
        return {
            meetingType: meetingType || this.defaultMeetingType,
            meetingPriority: meetingPriority || this.defaultMeetingPriority,
        };
    }
    setProfileForm(data) {
        this.profileForm.patchValue({
            coHostName: data.salePersonName,
            brokerName: data.salePersonBrokerName,
            hasSalePerson: data.hasSalePerson !== false,
            seminarSubEvent: data.seminarSubEvent,
            attendancePreference: data.attendancePreference,
            companyName: data.companyName,
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            mobileNumber: data.mobileNumber ? { number: data.mobileNumber, countryCode: data.countryCode } : null,
            extNumber: data.extNumber,
            jobTitle: data.jobTitle,
            department: data.department,
            countryId: data.countryId,
            institutionalInvestorTypeId: data.institutionalInvestorTypeId,
            otherInstitutionalInvestorType: data.otherInstitutionalInvestorType,
            assistantFirstName: data.assistantFirstName,
            assistantLastName: data.assistantLastName,
            assistantEmail: data.assistantEmail,
            assistantMobileNumber: data.assistantMobileNumber ? { number: data.assistantMobileNumber, countryCode: data.assistantCountryCode } : null,
            assistantExtNumber: data.assistantExtNumber
        });
    }
    saveMeetingRequest(meetingUpdateRequest) {
        this.registerInvestorService.saveInvestorMeetingRequest(meetingUpdateRequest, () => {
            this.alert.showSuccess(msg.success.dataSaved).then(() => {
                this.captureCompanySelectionSnapshot();
                this.registerInvestorService.fetchInvestorMeetingRequest();
            });
        });
    }
    cancelMeetingRequest(meetingRequestIds) {
        this.registerInvestorService.cancelInvestorMeetingRequestById(meetingRequestIds, () => {
            this.registerInvestorService.fetchInvestorMeetingRequest();
        });
    }
    onSaveProfile(profileFormValue) {
        const attendanceChanged = profileFormValue.attendancePreference !== this.attendancePreference;
        const previousAttendance = this.attendancePreference;
        if (attendanceChanged) {
            this.attendancePreference = profileFormValue.attendancePreference;
            this.defaultMeetingType = this.getDefaultMeetingType(this.attendancePreference);
            this.normalizeCompanyMeetingTypes();
        }
        const request = {
            hasSalePerson: profileFormValue.hasSalePerson !== false,
            salePersonName: profileFormValue.coHostName,
            brokerName: profileFormValue.brokerName ? profileFormValue.brokerName : profileFormValue.coHostName,
            seminarSubEvent: profileFormValue.seminarSubEvent,
            attendancePreference: profileFormValue.attendancePreference,
            companyName: profileFormValue.companyName,
            firstName: profileFormValue.firstName,
            lastName: profileFormValue.lastName,
            email: profileFormValue.email,
            mobileNumber: profileFormValue.mobileNumber ? profileFormValue.mobileNumber.e164Number : null,
            countryCode: profileFormValue.mobileNumber ? profileFormValue.mobileNumber.countryCode : null,
            extNumber: profileFormValue.extNumber,
            jobTitle: profileFormValue.jobTitle,
            department: profileFormValue.department,
            countryId: profileFormValue.countryId,
            institutionalInvestorTypeId: profileFormValue.institutionalInvestorTypeId,
            otherInstitutionalInvestorType: profileFormValue.otherInstitutionalInvestorType,
            assistantFirstName: profileFormValue.assistantFirstName,
            assistantLastName: profileFormValue.assistantLastName,
            assistantEmail: profileFormValue.assistantEmail,
            assistantMobileNumber: profileFormValue.assistantMobileNumber ? profileFormValue.assistantMobileNumber.e164Number : null,
            assistantCountryCode: profileFormValue.assistantMobileNumber ? profileFormValue.assistantMobileNumber.countryCode : null,
            assistantExtNumber: profileFormValue.assistantExtNumber,
        };
        this.registerInvestorService.saveRegisterInvestorInfo(request, () => {
            if (attendanceChanged) {
                this.saveCompanySelection(true);
            }
            else {
                this.alert.showSuccess(msg.success.dataSaved).then(() => {
                    this.captureProfileSnapshot();
                });
            }
        }, () => {
            if (attendanceChanged) {
                this.attendancePreference = previousAttendance;
                this.restoreCompanySelectionSnapshot();
            }
        });
    }
    buildCompanySelectionRequest() {
        const companiesFormArray = this.companySelectionForm.get('companies');
        const meetingUpdates = companiesFormArray.value.map((company) => ({
            investorMeetingRequestId: company.investorMeetingRequestId,
            registerCompanyId: company.registerCompanyId,
            meetingType: company.meetingType,
            priority: company.meetingPriority,
            registerInvestorId: this.investorProfile.registerInvestorId,
        }));
        const seminarSubEventControl = this.profileForm.get('seminarSubEvent');
        return {
            investorMeetingRequests: meetingUpdates,
            seminarSubEvent: seminarSubEventControl ? seminarSubEventControl.value : null,
        };
    }
    saveCompanySelection(reloadFromServer = false) {
        const request = this.buildCompanySelectionRequest();
        this.registerInvestorService.saveInvestorMeetingRequest(request, () => {
            if (reloadFromServer) {
                this.investorMeetingRequestService.getMeetingRequestUsingGET1(this.investorProfile.registerInvestorId)
                    .subscribe((response) => {
                    this.setCompanyForm(response.data);
                    this.captureCompanySelectionSnapshot();
                    this.captureProfileSnapshot();
                    this.registerInvestorService.investorMeetingRequest.next(response.data);
                    this.alert.showSuccess(msg.success.dataSaved);
                });
            }
            else {
                this.captureCompanySelectionSnapshot();
                this.registerInvestorService.fetchInvestorMeetingRequest();
                this.alert.showSuccess(msg.success.dataSaved);
            }
        });
    }
    onSaveCompanySelection(companySelection) {
        this.saveCompanySelection(false);
    }
    normalizeCompanyMeetingTypes() {
        const companiesFA = this.companySelectionForm.get('companies');
        companiesFA.controls.forEach(ctrl => {
            const currentType = ctrl.get('meetingType').value;
            const normalized = this.normalizeSelection(currentType);
            ctrl.get('meetingType').setValue(normalized.meetingType);
            ctrl.get('meetingPriority').setValue(this.defaultMeetingPriority);
        });
    }
    onSaveTimeSelection() {
        const slotsFormArray = this.timeSelectionForm.get('slots');
        const result = [];
        slotsFormArray.value.forEach(slot => {
            slot.slotPeriods.forEach(period => {
                result.push({
                    investorSlotId: period.investSlotId,
                    slotPeriodId: period.slotPeriodId,
                    available: period.isAvailable
                        ? InvestorSlotUpdate.AvailableEnum.Y
                        : InvestorSlotUpdate.AvailableEnum.N
                });
            });
        });
        const request = {
            investorSlots: result
        };
        this.investorSlotService.createAndUpdateInvestorSlotUsingPOST1(request).pipe(switchMap(() => this.investorSlotService.getInvestorSlotUsingGET1())).subscribe((response) => {
            const slots = response.data;
            this.setTimeSelectionForm(slots);
            this.captureTimeSelectionSnapshot();
            this.registerInvestorService.investorSlots.next(slots);
            this.alert.showSuccess(msg.success.dataSaved);
        });
    }
}
